export default __webpack_public_path__ + "773f1ca2656d2d56dd1df862e24c66ef.png";